import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgTest = function SvgTest(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_86_25008",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_86_25008)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_86_25008)",
        fillOpacity: 0.16,
        d: "M17.04 69.02q.763 1.646 2.575 1.647h48.77q1.812 0 2.575-1.648.765-1.647-.498-3.032L50.179 42.205V19.897h5.103q.545 0 .914-.355.368-.356.368-.909 0-.552-.368-.926a1.23 1.23 0 0 0-.914-.374H32.718q-.545 0-.914.356-.368.356-.368.908 0 .553.369.927.368.373.913.373h5.102v22.308L17.539 65.987q-1.262 1.385-.498 3.032"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_86_25008)",
        d: "M15.615 66.667q-1.812 0-2.575-1.648t.498-3.032l20.283-23.782V15.897h-5.103q-.545 0-.913-.373a1.27 1.27 0 0 1-.37-.927q0-.552.37-.908.368-.356.913-.356h22.564q.545 0 .914.374.368.374.368.926 0 .553-.368.909-.368.355-.914.355H46.18v22.308l20.282 23.782q1.262 1.385.498 3.032-.763 1.648-2.575 1.648zm-.487-2.564h49.744L43.615 39.14V15.897h-7.23v23.244z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_86_25008",
        x1: 17.321,
        x2: 70.49,
        y1: 43.999,
        y2: 43.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_86_25008",
        x1: 13.321,
        x2: 66.49,
        y1: 39.999,
        y2: 39.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgTest as ReactComponent };
//# sourceMappingURL=Test.svg.es.js.map
